import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { User } from '../model/user.model';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-new-account-creation',
    templateUrl: './new-account-creation.component.html',
    styleUrls: ['./new-account-creation.component.scss']
})
export class NewAccountCreationComponent implements OnInit {
    form!: UntypedFormGroup;

    user: User = new User();
    passwordToConfirm: string = '';

    hide: boolean = true;

    confirmed: boolean = false;
    changed: boolean = false;
    isConfirming: boolean = false;
    isLoading: boolean = false;
    confirmMsg: MsgModel = {};
    msg: MsgModel = {};

    constructor(private fb: UntypedFormBuilder, private authService: AuthService, private route: ActivatedRoute, private router: Router) {
        this.form = fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        });
    }

    ngOnInit(): void {
        this.isConfirming = true;

        this.confirmConfirmationCode();
    }

    confirmConfirmationCode() {
        let emailConfirmationCode: string = this.route.snapshot.paramMap.get('emailConfirmationCode') || '';

        if (emailConfirmationCode.length > 0) {
            this.isConfirming = true;
            this.authService.confirmNewUser(emailConfirmationCode).subscribe(
            {
                next: (res) => {
                    if (res.msg) {
                        this.confirmMsg = res.msg;
                        if (this.confirmMsg.SUCCESS) {
                            this.user = res.user;
                            this.confirmed = true;
                        } else {
                            this.confirmMsg.MSG = 'The confirmation code you provided is invalid, redirecting to login.';
                            setTimeout(() => {
                                this.router.navigateByUrl('/login');
                            }, 3000);
                        }
                    } else {
                        this.confirmMsg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.confirmMsg = err.msg;
                    } else {
                        this.confirmMsg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isConfirming = false;
                }
            });
        } else {
            this.confirmMsg = { MSG: 'Invalid confirmation code.', SUCCESS: false };
            this.isConfirming = false;
        }
    }

    changePassword() {
        if (this.confirmed && this.form.valid && this.form.get('password')?.value) {
            this.isLoading = true;

            this.user.USER_ID = this.form.get('username')?.value;
            this.user.PASSWORD = this.form.get('password')?.value;
            let emailConfirmationCode: string = this.route.snapshot.paramMap.get('emailConfirmationCode') || '';

            this.authService.updateNewUser(emailConfirmationCode, this.user).subscribe({
                next: (res) => {
                    if (res.msg) {
                        this.msg = res.msg;

                        if (this.msg.SUCCESS) {
                            this.msg.MSG += ' Redirecting to login in 3 seconds.';
                            this.changed = true;

                            setTimeout(() => {
                                this.router.navigateByUrl('/login');
                            }, 3000);
                        } else {
                            this.confirmMsg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    }
                },
                error: (err) => {
                    if (err.msg) {
                        this.confirmMsg = err.msg;
                    } else {
                        this.confirmMsg = { MSG: 'Server error.', SUCCESS: false };
                    }
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please check your inputs.' };
            this.isLoading = false;
        }
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
